<div class="w-full flex justify-center px-2 sm:px-0">
    <div class="w-full z-10 max-w-[1050px] py-6 sm:py-[114px]">
        <ng-content></ng-content>
    </div>
</div>